import { useState, useEffect } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";
import { cn } from "@/lib/utils";

// 可复用的 Markdown 预览组件
export const MarkdownPreview = ({ markdown }: { markdown: string }) => {
  const [previewHtml, setPreviewHtml] = useState("");

  // 监听 Markdown 内容变化，实时解析
  useEffect(() => {
    if (!markdown) {
      setPreviewHtml("");
      return;
    }

    // 配置 marked 解析规则
    marked.setOptions({
      breaks: true, // 支持 \n 换行（默认需要用两个空格+换行）
      gfm: true, // 支持 GitHub 风格的 Markdown（表格、删除线等）
      // sanitize: false // 关闭内置过滤，用 dompurify 更安全
    });

    // 1. 解析 Markdown 为原始 HTML
    const rawHtml = marked.parse(markdown);
    // 2. 过滤危险 HTML 标签（防 XSS 攻击，必须加！）
    const safeHtml = DOMPurify.sanitize(rawHtml as string);
    // 3. 更新预览 HTML
    setPreviewHtml(safeHtml);
  }, [markdown]);

  return (
    <div
      className="markdown-preview"
      dangerouslySetInnerHTML={{ __html: previewHtml }}
    />
  );
};

// 完整的编辑器 + 预览组件
const MarkdownEditor = ({
  defaultValue,
  preivew = false,
  className,
  onChange,
}: {
  defaultValue: string;
  preivew?: boolean;
  className?: string;
  onChange: (value: string) => void;
}) => {
  // 存储用户输入的 Markdown 文本
  const [markdown, setMarkdown] = useState(defaultValue);

  return (
    <div
      className={cn("w-full mdEditor", className)}
      style={{
        display: "flex",
        gap: "20px",
        padding: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* 编辑区 */}
      <div style={{ flex: 1 }}>
        {/* <h3>编辑区</h3> */}
        <textarea
          value={markdown}
          onChange={(e) => {
            setMarkdown(e.target.value);
            onChange(e.target.value);
          }}
          style={{
            width: "100%",
            height: "600px",
            padding: "15px",
            fontSize: "14px",
            border: "1px solid #e5e7eb",
            borderRadius: "6px",
            resize: "vertical",
          }}
          placeholder="请输入 Markdown 文本..."
        />
      </div>

      {/* 预览区 */}
      {preivew && (
        <div style={{ flex: 1 }}>
          <h3>预览区</h3>
          <div
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: "6px",
              padding: "20px",
              height: "600px",
              overflow: "auto",
              backgroundColor: "#fff",
            }}
          >
            <MarkdownPreview markdown={markdown} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MarkdownEditor;
